import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [entity, setEntity] = useState("");
  const load = async () => { const { data } = await api.get("/audit", { params: { entity: entity || undefined } }); setItems(data); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [entity]);
  return (
    <div className="space-y-5">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400">Keamanan</div>
        <h1 className="font-display text-3xl font-bold text-[#064E3B]">Audit Log</h1>
      </div>
      <div className="imsyaf-card p-4">
        <label className="text-xs">Filter Entity</label>
        <input className="imsyaf-input md:w-64" value={entity} onChange={(e) => setEntity(e.target.value)} placeholder="user / santri / pelanggaran / ..." />
      </div>
      <div className="imsyaf-card overflow-hidden">
        <table className="w-full text-sm zebra">
          <thead className="bg-slate-50"><tr>
            <th className="text-left px-4 py-2">Waktu</th><th className="text-left px-4 py-2">Aktor</th>
            <th className="text-left px-4 py-2">Aksi</th><th className="text-left px-4 py-2">Entity</th><th className="text-left px-4 py-2">Entity ID</th>
          </tr></thead>
          <tbody>{items.map((a) => (
            <tr key={a.id} className="border-t border-slate-100">
              <td className="px-4 py-2 text-xs">{a.created_at?.replace("T", " ").slice(0, 19)}</td>
              <td className="px-4 py-2">{a.actor_email} <span className="text-xs text-slate-500">({a.actor_role})</span></td>
              <td className="px-4 py-2"><span className="imsyaf-badge bg-green-50 text-green-800">{a.action}</span></td>
              <td className="px-4 py-2">{a.entity}</td>
              <td className="px-4 py-2 text-xs font-mono text-slate-500">{a.entity_id || "-"}</td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-slate-400">Belum ada log.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
